import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// for deletion
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const TutorList = () => {
  const [tutors, setTutors] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);

  useEffect(() => {
    if (token) {
      fetchtutors();
      fetchdepartment();
    }
  }, [token, currentPage, itemsPerPage, searchTerm]);

  useEffect(() => {
    fetchTutosByDepartment();
  }, [selectedDepartment]);

  const fetchTutosByDepartment = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-tutor/${selectedDepartment}?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTutors(response.data.data); // Update to your API structure
      setTotalItems(response.data.pagination.totalItems); // Assuming your API returns this
      // console.log("total items: ", response.data.pagination.totalItems);

      setTotalPages(response.data.pagination.totalPages);
      // console.log("total pages: ", response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch tutors:", error);
      setError("Failed to fetch tutors.");
    } finally {
      setLoading(false);
    }
  };

  const fetchtutors = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-tutor?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTutors(response.data.data); // Update to your API structure
      setTotalItems(response.data.pagination.totalItems); // Assuming your API returns this
      // console.log("total items: ", response.data.pagination.totalItems);

      setTotalPages(response.data.pagination.totalPages);
      // console.log("total pages: ", response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch tutors:", error);
      setError("Failed to fetch tutors.");
    } finally {
      setLoading(false);
    }
  };

  const fetchdepartment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setCurrentPage(0);
  // };

  const handleEdittutor = (tutor) => {
    navigate("/tutor-view", { state: { tutor } });
  };

  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeletetutor(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleDeletetutor = async (tutor) => {
    try {
      // const res = await deletetutor(tutor._id, reqHeader);
      const response = await fetch(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-tutor/${tutor._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();

        fetchtutors();
        navigate("/tutor-list");
      }
      // fetchtutors();
      // navigate("/tutor-list");
    } catch (err) {
      console.error("Error deleting tutor:", error);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(0); // Reset to first page on search
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleToggleStatus = async (item) => {
    try {
      const updatedStatus = !item.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/tutor-status-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        setTutors((prevtrader) =>
          prevtrader.map((b) =>
            b._id === item._id ? { ...b, status: updatedStatus } : b
          )
        );
        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle student status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          {/* <span className="text-md fw-medium text-secondary-light mb-0">
            Show
          </span>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            defaultValue="Select Number">
            <option value="Select Number" disabled>
              Select Number
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </select> */}
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>
          {/* Dropdown Field */}
          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
          >
            {/* <option value="" disabled>
              Department
            </option> */}
            <option value="">Select Departments</option>
            {departments.map((department) => (
              <option key={department._id} value={department._id}>
                {department.department_name}
              </option>
            ))}
          </select>
        </div>

        <Link
          to="/tutor-add"
          className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon
            icon="ic:baseline-plus"
            className="icon text-xl line-height-1"
          />
          Add New
        </Link>
      </div>
      <div className="card-body p-24">
        <div className="row gy-4">
          {tutors.length > 0 ? (
            tutors.map((tutor) => (
              <div className="col-xxl-3 col-md-6 user-grid-card">
                <div className="position-relative border radius-16 overflow-hidden h-100 d-flex flex-column">
                  <div className="dropdown position-absolute top-0 end-0 me-16 mt-16">
                    <button
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="bg-white-gradient-light w-32-px h-32-px radius-8 border border-light-white d-flex justify-content-center align-items-center text-white"
                    >
                      <Icon
                        icon="entypo:dots-three-vertical"
                        className="icon"
                      />
                    </button>
                    <ul className="dropdown-menu p-12 border bg-base shadow">
                      <li>
                        <button
                          onClick={() => handleToggleStatus(tutor)}
                          className={`dropdown-item btn-reset text-secondary-light bg-hover-${
                            tutor.status ? "success" : "danger"
                          }-100 text-hover-${
                            tutor.status ? "success" : "danger"
                          }-600 d-flex align-items-center gap-10`}
                        >
                          <Icon
                            icon={
                              tutor.status
                                ? "mdi:check-circle-outline"
                                : "mdi:cancel"
                            }
                            className="icon text-lg line-height-1"
                          />
                          {tutor.status ? "Active" : "Inactive"}
                        </button>
                      </li>
                      {tutor?.email !== "chris@educate2trade.com" && (
                        <li>
                          <button
                            onClick={() => handleDeleteClick(tutor)}
                            className="delete-item dropdown-item btn-reset text-secondary-light bg-hover-danger-100 text-hover-danger-600 d-flex align-items-center gap-10"
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="icon text-lg line-height-1"
                            />
                            Delete
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div className="ps-16 pb-16 pe-16 text-center mt-20 d-flex flex-column flex-grow-1">
                    <div className="mb-3">
                      <img
                        src={
                          tutor.profile_url ||
                          "assets/images/user-grid/user-grid-img14.png"
                        }
                        alt=""
                        className="border br-white border-width-2-px w-100-px h-100-px rounded-circle object-fit-cover"
                      />
                      <h6 className="text-lg mb-0 mt-4">
                        {tutor?.name ?? "null"}
                      </h6>
                      <span className="text-secondary-light d-block mb-16">
                        {tutor?.email ?? "null"}
                      </span>
                    </div>

                    <div className="center-border position-relative bg-danger-gradient-light radius-8 p-12 d-flex align-items-stretch gap-4 mb-3">
                      <div className="text-center w-50 d-flex flex-column">
                        <h6
                          className="text-md mb-1"
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                            minHeight: "40px",
                          }}
                        >
                          {tutor?.department?.department_name ?? "null"}
                        </h6>
                        <span className="text-secondary-light text-sm">
                          Department
                        </span>
                      </div>
                      <div className="text-center w-50 d-flex flex-column">
                        <h6
                          className="text-md mb-1"
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: "2",
                            WebkitBoxOrient: "vertical",
                            minHeight: "40px",
                          }}
                        >
                          {tutor?.tutor_id ?? "null"}
                        </h6>
                        <span className="text-secondary-light text-sm">
                          Tutor ID
                        </span>
                      </div>
                    </div>

                    <div className="mt-auto d-flex flex-column gap-2">
                      <button
                        onClick={() => handleEdittutor(tutor)}
                        className="bg-primary-50 text-primary-600 bg-hover-primary-600 hover-text-white p-10 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center justify-content-center fw-medium gap-2 w-100"
                      >
                        View Profile
                        <Icon
                          icon="solar:alt-arrow-right-linear"
                          className="icon text-xl line-height-1"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="d-flex justify-content-center w-100 text-center">
              No tutor found
            </p>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
          Showing{" "}
    {tutors.length === 0 
      ? "0" 
      : `${(currentPage - 1) * itemsPerPage + 1}`}{" "} to{" "}
            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
            entries
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  pointerEvents: currentPage === 1 ? "none" : "auto",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>

            {/* Current Page Number */}
            <li className="page-item">
              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                {currentPage}
              </span>
            </li>

            {/* Next Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
        {/* for deletion */}
        <Modal
          show={showDeleteModal}
          onHide={handleCloseDeleteModal}
          centered
          backdrop="static"
          size="sm"
        >
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-24 text-center">
              <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
              </span>
              <h6 className="text-lg fw-semibold text-primary-light mb-0">
                Are you sure you want to delete this tutor?
              </h6>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleCloseDeleteModal}
                  className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleConfirmDelete}
                  className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default TutorList;
